import * as angular from 'angular';

import { localizeHowtoUrl } from '@shared/utils/howto-url';

(function () {
    'use strict';

    angular
        .module('salesflare')
        .filter('howtoUrl', howtoUrl);

    // Explicit annotation since babel-plugin-angularjs-annotate only runs on .js files
    howtoUrl.$inject = ['$translate'];

    function howtoUrl($translate: any) {

        function howtoUrlFilter(url: string): string {

            return localizeHowtoUrl(url, $translate.use() || $translate.proposedLanguage());
        }

        // Stateful so links follow language changes, like the translate filter
        howtoUrlFilter.$stateful = true;

        return howtoUrlFilter;
    }
})();
